import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";

import {
  View,
  Edit,
  Delete,
  MakeDeactivate,
  MakeActivate,
  ChangePassword,
  SendCreds,
  Wallet,
  Login,
} from "../../util/Svg";
import { API } from "../../constant/api";
import useRequest from "../../hooks/useRequest";
const SVG_OBJ = {
  MakeActivate: <MakeActivate />,
  MakeDeactivate: <MakeDeactivate />,
};

const truncate = (input) =>
  input?.length > 200 ? `${input.substring(0, 200)}...` : input;
const DragHandle = sortableHandle(() => <span className="drag"></span>);
export const SortableContainer = sortableContainer(({ children }) => {
  return <tbody>{children}</tbody>;
});

export const SortableItem = sortableElement(
  ({
    data,
    tableData,
    links,
    onlyDate,
    page,
    date_format,
    date_time_format,
    renderAs = {},
    linksHelperFn = () => { },
    handleCheck

  }) => {

    const { role } = useSelector((state) => state.auth);

    return (
      <>
        <tr
        // key={`item-${data}`} index={data}
        >
          <td className="pl-0 py-2">
            <DragHandle />
          </td>
          {tableData.map((tData, index) => {
            let value;
            if (tData == "description") {
              value = (
                <p
                  dangerouslySetInnerHTML={{
                    __html: truncate(data[tData]),
                  }}
                ></p>
              );
            } else if (Object.keys(onlyDate).includes(tData)) {
              if (onlyDate[tData] === "date") {
                value = <Moment format={date_format}>{data[tData]}</Moment>;
              } else if (onlyDate[tData] === "dateTime") {
                value = (
                  <Moment format={date_time_format}>{data[tData]}</Moment>
                );
              }
            } else if (Object.keys(renderAs).includes(tData)) {
              value = renderAs[tData](data[tData], data._id, data);
            } else if (tData === "isActive") {
              if (data[tData]) {
                value = (
                  <span className="label label-lg label-light-success label-inline">
                    Activated
                  </span>
                );
              } else {
                value = (
                  <span className="label label-lg label-light-danger label-inline">
                    Deactivated
                  </span>
                );
              }
            } else if (tData === "isVerified") {
              if (data[tData]) {
                value = (
                  <span className="label label-lg label-light-success label-inline">
                    verified
                  </span>
                );
              } else {
                value = (
                  <span className="label label-lg label-light-danger label-inline">
                    Not verified
                  </span>
                );
              }
            } else if (tData === "status") {
              if (
                data[tData] === "Published" ||
                data[tData] === "Publish" ||
                data[tData] === "Draft"
              ) {
                if (data[tData] === "Published" || data[tData] === "Publish") {
                  value = (
                    <span className="label label-lg label-light-success label-inline">
                      Published
                    </span>
                  );
                } else {
                  value = (
                    <span className="label label-lg label-light-danger label-inline">
                      Draft
                    </span>
                  );
                }
              } else {
                if (data[tData] == "Approved" || data[tData] == "Unapproved") {
                  if (data[tData] == "Approved") {
                    value = (
                      <span className="label label-lg label-light-success label-inline">
                        Approved
                      </span>
                    );
                  } else {
                    value = (
                      <span className="label label-lg label-light-danger label-inline">
                        Unapproved
                      </span>
                    );
                  }
                }
              }
            } else if (tData == "message") {
              value = truncate(data[tData]);
            } else if (tData == "amount") {
              value = `$${data[tData]}`;
            } else if (tData == "country") {
              // value = "131"
              if (data.countryId) {
                value = data.countryId.name;
              } else if (data.country) {
                let countries = "";
                if (data.country && data.country.length > 0) {
                  data.country.forEach((c) => {
                    countries += c.name + ", ";
                  });
                  if (countries != "") {
                    countries = countries.slice(0, -2);
                  }
                }
                value = countries;
              }
            } else if (
              (typeof data.vendor === "object" ||
                typeof data.user === "object") &&
              (tData == "vendor" || tData == "user")
            ) {
              if (data.vendor && data.vendor.businessName) {
                value = data.vendor.businessName;
              } else if (data.user && data.user.businessName) {
                value = data.user.businessName;
              } else if (data.user && data.user.name) {
                value = data.user.name;
              }
            } else if (tData == "category") {
              if (data.category && data.category.name) {
                value = data.category.name;
              } else {
                value = "-";
              }
            } else if (tData == "productCategories") {
              if (data.productCategoryId) {
                let pcategories = "";
                if (
                  data.productCategoryId &&
                  data.productCategoryId.length > 0
                ) {
                  data.productCategoryId.forEach((pc) => {
                    pcategories += pc.name + ", ";
                  });
                  if (pcategories != "") {
                    pcategories = pcategories.slice(0, -2);
                  }
                }
                value = pcategories;
              }
            } else if (tData == "to") {
              value = data && data.to && data.to.name ? data.to.name : data.to;
            } else if (tData === "answer") {
              value = (
                <p
                  dangerouslySetInnerHTML={{
                    __html: truncate(data[tData]),
                  }}
                ></p>
              );
            } else if (tData === "showOnSearch") {
              return (
                <>
                  <td>
                    <input
                      type="checkbox"
                      style={{ height: "20px" }}
                      defaultChecked={data?.showOnSearch ? true : false}
                      onClick={() => handleCheck.click(data._id, data?.showOnSearch ? false : true)}
                    />
                  </td>

                </>
              );
            }
            // else if (
            //   tData == "likes" ||
            //   tData == "shares" ||
            //   tData == "plays"
            // ) {
            //   value = "-";
            // }
            //  else if (tData === "options") {
            //   return (
            //     <>
            //       <td>
            //         <input
            //           type="checkbox"
            //           style={{ height: "20px" }}
            //           {...register(`filterrequired_${data.value}`)}
            //         />
            //       </td>
            //       <td style={{ paddingLeft: "60px" }}>
            //         <input
            //           type="checkbox"
            //           style={{ height: "20px" }}
            //           {...register(`filter_${data.value}`)}
            //         />
            //       </td>

            //       <td style={{ paddingLeft: "60px" }}>
            //         <span>{order}</span>
            //       </td>
            //       <td style={{ paddingLeft: "60px" }}>{data.label}</td>
            //     </>
            //   );
            // }
            else {
              value = data[tData];
            }

            return (
              <td key={index} className="py-5">
                <div className="d-flex align-items-center">
                  <div className="text-dark-75 mb-1  font-size-lg">
                    {value}
                    {/* <span className="False_text">False</span>  
                     <span className="true_text">True</span>   */}

                    {/* {tData === "description" ? (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: truncate(data[tData]),
                              }}
                            ></p>
                          ) : tData === "createdAt" ? (
                            onlyDate ? (
                              <Moment format={date_format}>
                                {data[tData]}
                              </Moment>
                            ) : (
                              <Moment format={date_time_format}>
                                {data[tData]}
                              </Moment>
                            )
                          ) : tData === "isActive" ? (
                            data[tData] == "true" ? (
                              <span className="label label-lg label-light-success label-inline">
                                Activated
                              </span>
                            ) : (
                              <span className="label label-lg label-light-danger label-inline">
                                Deactivated
                              </span>
                            )
                          ) : (
                            data[tData]
                          )} */}
                  </div>
                </div>
              </td>
            );
          })}

          <td style={{ whiteSpace: "nowrap" }} className="text-left pr-2">
            {links?.map((link, index) => {
              let name = link.name;
              let svg;

              svg = SVG_OBJ[linksHelperFn(name, data)];

              if (name == "Edit" || name == "Add Offer") {
                svg = <Edit />;
              } else if (name == "Delete") {
                svg = <Delete />;
              } else if (name == "View" || name == "View History") {
                svg = <View />;
              } else if (name == "Deactivate" && !data.isActive) {
                svg = <MakeActivate />;
              } else if (name == "Draft" && data.status != "Publish") {
                svg = <MakeActivate />;
              } else if (name == "Unapproved" && data.status != "Approved") {
                svg = <MakeActivate />;
              } else if (name == "Activate" && data.isActive) {
                svg = <MakeDeactivate />;
              }
              // else if (name == "DeactivateFeatued" && !data.isFeatured) {
              //   svg = <MakeActivate />;
              // } else if (name == "ActivateFeatued" && data.isFeatured) {
              //   svg = <MakeDeactivate />;
              // }
              else if (name == "Publish" && data.status != "Draft") {
                svg = <MakeDeactivate />;
              } else if (name == "Approved" && data.status != "Unapproved") {
                svg = <MakeDeactivate />;
              } else if (name == "ChangePassword") {
                svg = <ChangePassword />;
              } else if (name == "SendCreds" || name == "Send Alert") {
                svg = <SendCreds />;
              } else if (name == "Wallet") {
                svg = <Wallet />;
              } else if (name == "Login") {
                svg = <Wallet />;
              } else if (
                (name == "Approve" && data.approvalStatus == "pending") ||
                (name == "Approve" && data.approvalStatus == "rejected")
              ) {
                svg = <MakeActivate />;
              } else if (name == "Reject" && data.approvalStatus == "pending") {
                svg = <MakeDeactivate />;
              } else if (name == "Verified" && data.isApproved) {
                svg = <MakeDeactivate />;
              } else if (name == "Pending" && !data.isApproved) {
                svg = <MakeActivate />;
              }

              if (link.isLink) {
                return (
                  !data.comment && (
                    <Link
                      key={index}
                      to={
                        link.extraData
                          ? { pathname: `${link.to}/${data._id}`, page }
                          : `${link.to}/${data._id}`
                      }
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      data-container="body"
                      data-boundary="window"
                      title={link.title || name}
                      data-original-title={link.title || name}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        {svg}
                      </span>
                    </Link>
                  )
                );
              } else {
                return (
                  <Fragment key={index}>
                    {svg && (
                      <a
                        key={index}
                        className={`btn btn-icon btn-light mr-2 ${name === "Delete"
                          ? "btn-hover-danger confirmDelete"
                          : "btn-hover-primary"
                          }  btn-sm `}
                        data-toggle="tooltip"
                        data-placement="top"
                        data-container="body"
                        data-boundary="window"
                        title={link.title || name}
                        data-original-title={link.title || name}
                      >
                        <span
                          onClick={() => link.click(data._id, data)}
                          className={`svg-icon svg-icon-md ${name === "Delete"
                            ? "svg-icon-danger"
                            : "svg-icon-primary"
                            }`}
                        >
                          {svg}
                        </span>
                      </a>
                    )}
                  </Fragment>
                );
              }
            })}
          </td>
        </tr>
      </>
    );
  }
);

const Table = ({
  mainData,
  tableHeading, //keys
  tableData, //values
  links,
  sortingHandler,

  currentSort,
  onlyDate,
  page,
  dontShowSort = [],
  renderAs = {},
  sorting,
  responseKey,
  linksHelperFn = () => { },
  handleCheck,
  per_page = 10,
  orderHandler,
  sortObj
}) => {



  const { date_format, date_time_format } = useSelector(
    (state) => state.setting
  );

  const [items, setItems] = useState([...mainData]);
  const { request, response, clear } = useRequest();

  useEffect(() => {
    setItems(mainData);
  }, [mainData]);

  useEffect(() => {
    if (response?.status) {
      setItems(response[`${responseKey}`]);
      clear();
    }
  }, [response]);

  const onSortEnd = ({ oldIndex, newIndex }) => {

    if (oldIndex == newIndex) {
      return;
    }

    request("post", `${sortObj.api}/sort?${orderHandler()}`, {
      ...sortObj.data,
      oldOrder: oldIndex + 1 + (page - 1) * per_page,
      newOrder: newIndex + 1 + (page - 1) * per_page,
    });
  };

  return (
    <div className="table-responsive">
      <table
        className="table dataTable table-head-custom table-head-bg table-borderless table-vertical-center"
        id="taskTable"
      >
        <thead>
          <tr className="text-uppercase">
            {sorting && <th></th>}
            {tableHeading.map((heading, index) => (
              <th
                onClick={() => sortingHandler(heading)}
                key={index}
                className={`${currentSort.sortBy == heading
                  ? `sorting_${currentSort.order}`
                  : dontShowSort.includes(heading)
                    ? ""
                    : "sorting"
                  }`}
                style={{
                  width:
                    heading === "answer"
                      ? "400px"
                      : heading === "description" || heading === "title"
                        ? "200px"
                        : heading === "phone number"
                          ? "120px"
                          : "",
                }}
              >
                <a className="no_sort">{heading}</a>
              </th>
            ))}
            {links && links.length > 0 ? (
              <th className="text-left ActionText">Action</th>
            ) : null}
          </tr>
        </thead>
        {sorting ? (
          <SortableContainer useDragHandle onSortEnd={onSortEnd}>
            {items.map((data, i) => (
              <SortableItem
                key={`item-${i}`}
                index={i}
                data={data}
                tableData={tableData}
                onlyDate={onlyDate}
                links={links}
                page={page}
                date_format={date_format}
                date_time_format={date_time_format}
                renderAs={renderAs}
                linksHelperFn={linksHelperFn}
                handleCheck={handleCheck}
              />
            ))}
          </SortableContainer>
        ) : (
          <tbody>
            {mainData.length > 0 &&
              mainData.map((data) => (
                <tr key={data._id}>
                  {tableData.map((tData, index) => {
                    let value;
                    if (tData == "description") {
                      value = (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: truncate(data[tData]),
                          }}
                        ></p>
                      );
                    } else if (tData == "country") {
                      value = data?.other_fields?.country?.name;
                    } else if (tData == "sport") {
                      value = data?.other_fields?.sportName?.name;
                    } else if (tData == "contact") {
                      let phoneNumber = data?.other_fields?.contact;
                      if (phoneNumber) {
                        if (data.other_fields && data.other_fields.countryCode && data.other_fields.countryCode.dial_code) {
                          phoneNumber = data.other_fields.countryCode.dial_code + ' ' + phoneNumber;
                        }
                      } else {
                        phoneNumber = '-';
                      }

                      value = phoneNumber;
                    }
                    else if (tData == "contactNo") {
                      let phoneNumber = data?.contactNo;
                      if (phoneNumber) {
                        if (data.countryCode) {
                          phoneNumber = data.countryCode.dial_code + ' ' + phoneNumber;
                        }
                      } else {
                        phoneNumber = '-';
                      }

                      value = phoneNumber;
                    }
                    else if (Object.keys(onlyDate).includes(tData)) {
                      if (onlyDate[tData] === "date") {
                        value = (
                          <Moment format={date_format}>{data[tData]}</Moment>
                        );
                      } else if (onlyDate[tData] === "dateTime") {
                        value = (
                          <Moment format={date_time_format}>{data[tData]}</Moment>
                        );
                      }
                    } else if (Object.keys(renderAs).includes(tData)) {
                      value = renderAs[tData](data[tData], data._id, data);
                    } else if (tData == "isVerified") {
                      if (data[tData] == true) {
                        value = "Yes";
                      } else {
                        value = "No";
                      }
                    } else if (tData == "isActive") {
                      if (data[tData] == true || data[tData] == "true") {
                        value = (
                          <span className="label label-lg label-light-success label-inline">
                            Activated
                          </span>
                        );
                      } else {
                        value = (
                          <span className="label label-lg label-light-danger label-inline">
                            Deactivated
                          </span>
                        );
                      }
                    } else if (tData == "approvalStatus") {
                      if (data[tData] == true || data[tData] == "Approved") {
                        value = (
                          <span className="label label-lg label-light-success label-inline">
                            Approved
                          </span>
                        );
                      } else if (
                        data[tData] == true ||
                        data[tData] == "Rejected"
                      ) {
                        value = (
                          <span className="label label-lg label-light-danger label-inline">
                            Rejected
                          </span>
                        );
                      } else if (
                        data[tData] == true ||
                        data[tData] == "On-Hold"
                      ) {
                        value = (
                          <span className="label label-lg label-light-danger label-inline">
                            On-Hold
                          </span>
                        );
                      }else if (
                        data[tData] == true ||
                        data[tData] == "Pilot"
                      ) {
                        value = (
                          <span className="label label-lg label-light-info label-inline">
                            Pilot
                          </span>
                        );
                      }else {
                        value = (
                          <span className="label label-lg label-light-warning label-inline">
                            Pending
                          </span>
                        );
                      }
                    } else if (tData == "message") {
                      value = truncate(data[tData]);
                    } else if (tData == "amount") {
                      value = `$${data[tData]}`;
                    } else if (tData == "image" && typeof data[tData] != 'undefined') {
                      value = (
                        <img
                          src={`${data[tData]}`}
                          alt=""
                          data-fancybox
                          height={50}
                          width={80}
                          style={{ cursor: "pointer" }}
                        />
                      );
                    } else if (tData == "video" && typeof data[tData] != 'undefined') {

                      value = (
                        <video
                          src={`${data[tData]}`}
                          alt=""
                          // data-fancybox
                          height={50}
                          width={80}
                          style={{ cursor: "pointer" }}
                        />
                      );
                    }
                    else if (tData == "document" && data[tData]) {
                      value = (
                        <div style={{ cursor: "pointer" }}>
                          <img
                            src={`/assets/img/pdf-img.png`}
                            alt=""
                            height={50}
                            width={80}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      );
                    }
                    else if (tData === "answer") {
                      value = (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: truncate(data[tData]),
                          }}
                        ></p>
                      );
                    } else if (tData == "lastPaymentOn") {
                      const lastPaymentDate = data?.subscription?.subscriptionId?.lastTransactionDate
                        ? new Date(data.subscription.subscriptionId.lastTransactionDate)
                        : null;

                      const sixtyDaysAgo = new Date();
                      sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);

                      if (!lastPaymentDate) {
                        value = '-';
                      } else {
                        const formattedDate = moment(lastPaymentDate).format(date_format);

                        if (lastPaymentDate < sixtyDaysAgo) {
                          value = (
                            <span className="label label-lg label-light-danger label-inline">
                              {formattedDate}
                            </span>
                          );
                        } else {
                          value = formattedDate
                        }
                      }
                    }
                    else if (tData == "lastTransactionDate") {
                      const lastPaymentDate = data?.lastTransactionDate
                        ? new Date(data.lastTransactionDate)
                        : null;

                      const sixtyDaysAgo = new Date();
                      sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);

                      if (!lastPaymentDate) {
                        value = '-';
                      } else {
                        const formattedDate = moment(lastPaymentDate).format(date_format);

                        if (lastPaymentDate < sixtyDaysAgo) {
                          value = (
                            <span className="label label-lg label-light-danger label-inline">
                              {formattedDate}
                            </span>
                          );
                        } else {
                          value = formattedDate
                        }
                      }
                    }
                    else {
                      value = data[tData];
                    }

                    return (
                      <td key={index} className="py-5" >
                        <div className="d-flex align-items-center">
                          <div className="text-dark-75 mb-1  font-size-lg">
                            {value}
                            {/* <span className="False_text">False</span>  
                        <span className="true_text">True</span>   */}

                            {/* {tData === "description" ? (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: truncate(data[tData]),
                              }}
                            ></p>
                          ) : tData === "createdAt" ? (
                            onlyDate ? (
                              <Moment format={date_format}>
                                {data[tData]}
                              </Moment>
                            ) : (
                              <Moment format={date_time_format}>
                                {data[tData]}
                              </Moment>
                            )
                          ) : tData === "isActive" ? (
                            data[tData] == "true" ? (
                              <span className="label label-lg label-light-success label-inline">
                                Activated
                              </span>
                            ) : (
                              <span className="label label-lg label-light-danger label-inline">
                                Deactivated
                              </span>
                            )
                          ) : (
                            data[tData]
                          )} */}
                          </div>
                        </div>
                      </td>
                    );
                  })}

                  <td className="text-left pr-2">
                    {links?.map((link, index) => {
                      let name = link.name;
                      let svg;

                      if (name == "Edit") {
                        svg = <Edit />;
                      } else if (name == "Delete") {
                        svg = <Delete />;
                      } else if (name == "View") {
                        svg = <View />;
                      } else if (
                        name == "Deactivate" &&
                        data.isActive != true &&
                        data.isActive != "true"
                      ) {
                        svg = <MakeActivate />;
                      } else if (
                        name == "Activate" &&
                        data.isActive != false &&
                        data.isActive != "false"
                      ) {
                        svg = <MakeDeactivate />;
                      } else if (
                        name == "Rejected" &&
                        data.approvalStatus == "Pending"
                      ) {
                        svg = <MakeActivate />;
                      } else if (
                        name == "Approved" &&
                        data.approvalStatus == "Pending"
                      ) {
                        svg = <MakeDeactivate />;
                      } else if (name == "ChangePassword") {
                        svg = <ChangePassword />;
                      } else if (name == "SendCreds") {
                        svg = <SendCreds />;
                      } else if (name == "Wallet") {
                        svg = <Wallet />;
                      } else if (name == "Login") {
                        svg = <Wallet />;
                      }

                      if (link.isLink) {
                        return (
                          <Link
                            key={index}
                            to={
                              link.extraData
                                ? { pathname: `${link.to}/${data._id}`, page }
                                : `${link.to}/${data._id}`
                            }
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-container="body"
                            data-boundary="window"
                            title={link.title || name}
                            data-original-title={link.title || name}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              {svg}
                            </span>
                          </Link>
                        );
                      } else {
                        return (
                          <Fragment key={index}>
                            {svg && (
                              <a
                                key={index}
                                className={`btn btn-icon btn-light mr-2 ${name === "Delete"
                                  ? "btn-hover-danger confirmDelete"
                                  : "btn-hover-primary"
                                  }  btn-sm `}
                                data-toggle="tooltip"
                                data-placement="top"
                                data-container="body"
                                data-boundary="window"
                                title={link.title || name}
                                data-original-title={link.title || name}
                              >
                                <span
                                  onClick={() =>
                                    link.click(
                                      data._id,
                                      name,
                                      data?.organizationCode
                                    )
                                  }
                                  className={`svg-icon svg-icon-md ${name === "Delete"
                                    ? "svg-icon-danger"
                                    : "svg-icon-primary"
                                    }`}
                                >
                                  {svg}
                                </span>
                              </a>
                            )}
                          </Fragment>
                        );
                      }
                    })}
                  </td>
                </tr>
              ))}
            {mainData.length == 0 && (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  {" "}
                  Record not found.
                </td>
              </tr>
            )}
          </tbody>
        )}

      </table>
    </div>
  );
};

export default Table;
